import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function CrearCuentaPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [tipoUsuario, setTipoUsuario] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleTipoUsuarioChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(opt => opt.value);
    setTipoUsuario(selectedOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = { name, email, password, tipoUsuario };

    try {
      const response = await fetch('https://marketluz.com/laravel8/public/api/crear-usuario', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setMessage('✅ Cuenta creada exitosamente.');
        setError('');
        setName('');
        setEmail('');
        setPassword('');
        setTipoUsuario([]);
      } else {
        const errorData = await response.json();
        setError(errorData.message || '❌ No se pudo crear la cuenta.');
        setMessage('');
      }
    } catch (err) {
      setError(`❌ Error de red: ${err.message}`);
      setMessage('');
    }
  };

  return (
  <div className="container py-5">
    <div className="row justify-content-center">
      <div className="col-12 col-md-8 col-lg-6">
        <div className="card shadow-sm border-0 rounded-4 p-5" style={{ maxWidth: '500px', width: '100%' }}>
          <h3
            className="fw-bold text-primary mb-4 text-center"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Crear cuenta
          </h3>

          {message && <div className="alert alert-success">{message}</div>}
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            {/* Nombre */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Nombre completo</label>
              <input
                type="text"
                className="form-control form-control-lg rounded-3"
                placeholder="Ingresa tu nombre"
                value={name}
                required
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* Correo */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Correo electrónico</label>
              <input
                type="email"
                className="form-control form-control-lg rounded-3"
                placeholder="ejemplo@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Contraseña */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Contraseña</label>
              <input
                type="password"
                className="form-control form-control-lg rounded-3"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {/* Tipo de usuario */}
            <div className="mb-3">
              <label className="form-label fw-semibold">Tipo de usuario</label>
              <select
                multiple
                className="form-select rounded-3"
                value={tipoUsuario}
                onChange={handleTipoUsuarioChange}
              >
                <option value="0">Vendedor</option>
                <option value="1">Comprador</option>
                <option value="2">Bloguero</option>
                <option value="3">Video Bloguero</option>
              </select>
              <small className="form-text text-muted">
                Mantén presionada Ctrl (Windows) o Cmd (Mac) para seleccionar múltiples opciones.
              </small>
            </div>

            {/* Botón */}
            <button type="submit" className="btn btn-primary btn-lg w-100 rounded-pill shadow-sm mt-3">
              Crear cuenta
            </button>
          </form>

          <div className="text-center mt-3">
            <span className="small">¿Ya tienes cuenta? </span>
            <Link to="/login" className="text-primary fw-semibold text-decoration-none">
              Iniciar sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  </div>
);
}

export default CrearCuentaPage;